import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number, currentLanguage: string): string {
    if (!value) return '';

    if (currentLanguage === 'en') {
      // Formata para USD com espaço no milhar e ponto no decimal
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(value).replace(/,/g, ' ');
    } else {
      // Formata para BRL ou outro padrão
      const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(value);
    }
  }
}